import axiosInstance from './axiosInstance'
import { TrainingPlan } from '../pages/UserTrainingPlans/TrainingPlansTable/utils'

const getAllTrainingPlans = () => {
  return axiosInstance.get(`/api/admin/trainingplan/templates`, {
    withCredentials: true,
  })
}

const getTemplate = () => {
  return axiosInstance.get(`/api/admin/trainingplan/sampletemplate`)
}

const uploadPlan = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return axiosInstance.post(`/api/v7/admin/trainingplan/upload`, formData, {
    withCredentials: true,
  })
}

const getUploadQueueStatus = () => {
  return axiosInstance.get(`/api/v7/admin/trainingplan/upload/queue/status`, {
    withCredentials: true,
  })
}

const startUploadQueue = () => {
  return axiosInstance.post(
    `/api/v7/admin/trainingplan/upload/queue/start`,
    {},
    { withCredentials: true }
  )
}

const finishUploadQueue = () => {
  return axiosInstance.post(
    `/api/v7/admin/trainingplan/upload/queue/finish`,
    {},
    { withCredentials: true }
  )
}

const notifyUploadSummary = (payload) => {
  return axiosInstance.post(
    `/api/v7/admin/trainingplan/upload/summary`,
    payload,
    { withCredentials: true }
  )
}

const getUserTrainingPlans = (userId: number) => {
  return axiosInstance.get(`/api/admin/trainingplan/users/${userId}`)
}

const updateUserTrainingPlan = (
  userId: number,
  planId: number,
  plan: TrainingPlan
) => {
  return axiosInstance.put(`/api/admin/user/${userId}/plans/${planId}`, plan)
}

type IntervalChangeEntry = {
  sessionId: number
  deleted: number[]
  modified: {
    id: number
    title: string
    intervalNo: number
    goalTimeMs: number | null
    goalDistanceMeters: number | null
    goalPaceMsPerKm: number | null
    goalPaceExpression: string | null
  }[]
  added: {
    title: string
    intervalNo: number
    goalTimeMs: number | null
    goalDistanceMeters: number | null
    goalPaceMsPerKm: number | null
    goalPaceExpression: string | null
  }[]
}

const getPlanVersions = (userId: number | string, planId: number | string) => {
  return axiosInstance.get(`/api/admin/user/${userId}/plans/${planId}/versions`)
}

const getVersionChangelog = (
  userId: number | string,
  planId: number | string,
  versionId: number | string
) => {
  return axiosInstance.get<
    {
      id: number
      sessionTitle: string
      action: 'created' | 'updated' | 'deleted'
    }[]
  >(`/api/admin/user/${userId}/plans/${planId}/versions/${versionId}/changelog`)
}

const batchUpdateSessions = (
  userId: number | string,
  planId: number | string,
  data: {
    deleted?: number[]
    modified?: {
      id: number
      title: string
      date: string
      activityType: string
      sportType: string
    }[]
    added?: {
      title: string
      activityType: string
      sportType: string
      date: string
      goalDistanceMeters?: number | null
      goalPaceMsPerKm?: number | null
      goalTimeMs?: number | null
    }[]
    intervalChanges?: IntervalChangeEntry[]
  }
) => {
  return axiosInstance.post(
    `/api/admin/user/${userId}/plans/${planId}/sessions/batch`,
    data
  )
}

const trainingplansApi = {
  getAllTrainingPlans,
  getTemplate,
  uploadPlan,
  getUploadQueueStatus,
  startUploadQueue,
  finishUploadQueue,
  notifyUploadSummary,
  getUserTrainingPlans,
  updateUserTrainingPlan,
  batchUpdateSessions,
  getPlanVersions,
  getVersionChangelog,
}

export default trainingplansApi
